module.exports = __webpack_public_path__ + "img/action-save.0c8ae3d5.svg";